module.exports = __webpack_public_path__ + "assets/overlay.6a3daa66.svg";